import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import { withTranslation } from "react-i18next";
import i18n from "../../../i18n";
import languages from "../../../common/languages";
import { Languages } from "../../../constants/enums";

const LanguageDropdown = () => {
  const [selectedLang, setSelectedLang] = useState("");
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE") ||  Languages.ES;
    setSelectedLang(currentLanguage);
    i18n.changeLanguage(currentLanguage);
  }, []);

  const changeLanguageAction = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    setSelectedLang(lang);
  };

  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item " tag="button">
          <img
            src={get(languages, `${selectedLang}.flag`)}
            alt="language-flag"
            height="16"
            className="me-1"
          />
        </DropdownToggle>
        <DropdownMenu className="custom-dropdown-menu language-dropdown dropdown-menu-end border-0">
          {map(Object.keys(languages), (key) => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`dropdown-item ${selectedLang === key ? "active" : ""}`}
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt={`flag-${key}`}
                className="me-2"
                height="14"
              />
              <span className="align-middle">
                {get(languages, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default withTranslation()(LanguageDropdown);
